import { EnumSelect } from '~/components/GenericForm/EnumSelect';
import { Enum } from '~/data/enums';
import { PersonnelGroupFilterIndex } from '~/scenes/PortalModules/Analytics/People/AbsenceCalendarReport/data';
import { UsePersonnelGroupsFiltersOutput } from '~/scenes/PortalModules/Analytics/People/AbsenceCalendarReport/PersonnelGroupsFilters/usePersonnelGroupsFilters';

export type PersonnelGroupsFiltersProps = UsePersonnelGroupsFiltersOutput & {
  isOptionDisabled: (group: PersonnelGroupFilterIndex, option: Enum) => boolean;
};

export const PersonnelGroupsFilters = (props: PersonnelGroupsFiltersProps) => {
  const { filters, enabledPersonnelGroupFilters, isOptionDisabled } = props;

  return (
    <>
      {enabledPersonnelGroupFilters.map((pgFilter) => {
        const personnelGroupFilter = filters[pgFilter];

        if (!personnelGroupFilter) {
          return <></>;
        }

        const { label, options, value, setValue, fieldWidth } =
          personnelGroupFilter;

        return (
          <EnumSelect
            key={`personnel-group-filter-${pgFilter}`}
            label={label}
            enumOptions={options}
            value={value}
            onChange={(event) => {
              const newValue = event.target.value;

              if (typeof newValue === 'string') {
                setValue(newValue);
              } else {
                setValue('');
              }
            }}
            size={'small'}
            shrink={true}
            sx={{ width: fieldWidth > 150 ? fieldWidth : 150 }}
            includeEmptyOption={true}
            isOptionDisabled={(e) => isOptionDisabled(pgFilter, e)}
          />
        );
      })}
    </>
  );
};
